import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { Clamp } from "@/components/General/Clamp/clamp.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import {
    useBreakpoint,
    withBreakpoints
} from "@/utils/breakpoints/breakpoints.provider";

type Props = {
    text: string;
    color: string;
    readMoreMobile: boolean;
    readMoreDesktop: boolean;
};

const _TextComponent = ({
    text,
    color,
    readMoreMobile,
    readMoreDesktop
}: Props) => {
    const { t } = useGranite();
    const { breakpoints } = useBreakpoint();

    let clampEnabled = readMoreDesktop && readMoreMobile;
    if (!clampEnabled) {
        clampEnabled = breakpoints.md ? readMoreDesktop : readMoreMobile;
    }

    return (
        <>
            {clampEnabled && (
                <Clamp
                    lines={4}
                    withToggle
                    showMoreElement={({ toggle }: any) => (
                        <Button
                            type={"button"}
                            color={"link"}
                            className={cn("p-0", "mb-3")}
                            onClick={toggle}
                        >
                            {t("textComponent.link.showMore")}
                            <i className={"las la-angle-down ml-1"} />
                        </Button>
                    )}
                    showLessElement={({ toggle }: any) => (
                        <Button
                            type={"button"}
                            color={"link"}
                            className={cn("p-0", "mb-3")}
                            onClick={toggle}
                        >
                            {t("textComponent.link.showLess")}
                            <i className={"las la-angle-up ml-1"} />
                        </Button>
                    )}
                >
                    <div
                        className={cn("rich-text-content", color)}
                        dangerouslySetInnerHTML={{ __html: text }}
                    />
                </Clamp>
            )}
            {!clampEnabled && (
                <div
                    className={cn("rich-text-content", color)}
                    dangerouslySetInnerHTML={{ __html: text }}
                />
            )}
        </>
    );
};

export const TextComponent = withBreakpoints(_TextComponent);
